import { supabase } from "@/integrations/supabase/client";

/**
 * Records an admin-visible notification when a testimonial intake fails
 * (client validation or a save error). Best-effort: never blocks or throws
 * into the visitor's submit flow.
 */
export async function reportTestimonialFailure(input: {
  reason: string;
  fields?: string[];
  email?: string;
  source?: string;
}): Promise<void> {
  try {
    await supabase.rpc("report_testimonial_failure", {
      _reason: input.reason.slice(0, 200),
      _fields: (input.fields ?? []).slice(0, 12),
      _email: (input.email ?? "").slice(0, 160) || null,
      _source: input.source ?? "/testimonial-intake",
    });
  } catch (err) {
    console.warn("[testimonial] failure report not delivered", err);
  }
}
